<template>
  <Head title="Términos y Condiciones - Realgestion" />
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-darkblue-700 mb-6">Términos y Condiciones</h1>
    
    <div class="prose max-w-none">
      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">1. Aceptación de los Términos</h2>
      <p class="mb-4">
        Al acceder y utilizar el sitio web de Realgestion C.A., usted acepta estos términos y condiciones en su totalidad.
        Si no está de acuerdo con estos términos, por favor no utilice este sitio web.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">2. Uso del Sitio</h2>
      <p class="mb-4">
        Este sitio web está destinado para uso comercial y venta de productos de refrigeración y línea blanca.
        Usted se compromete a utilizar este sitio web de manera legal y de acuerdo con estos términos.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">3. Cuentas de Usuario</h2>
      <p class="mb-4">
        Para realizar compras en nuestro sitio, deberá crear una cuenta de usuario. Usted es responsable de mantener
        la confidencialidad de su cuenta y contraseña.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">4. Precios y Pagos</h2>
      <p class="mb-4">
        Todos los precios están sujetos a cambios sin previo aviso. Los pagos deben realizarse según los métodos
        disponibles en nuestra plataforma.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">5. Modificaciones</h2>
      <p class="mb-4">
        Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor
        inmediatamente después de su publicación en el sitio web.
      </p>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '@/Layouts/WebLayout.vue'

export default {
  layout: WebLayout,
  components: {
    Head
  }
}
</script> 